import React from "react";
import { Box } from "@curves/ui-base";
import { PdfComponent } from "@icoach/components/";

const PDFTest = React.forwardRef((props, ref) => {
	const url2 = "https://localhost:5011/members/1088/doc/cycle-purchase-effection/337/contract.pdf?t=A000SVPnZK9";
	const url3 = "https://localhost:5011/members/1088/doc/cycle-purchase-effection/340/contract.pdf?t=A000SVPnZK9";
	const urls = [url2, url3];
	return (
		<Box className="main-container-spacing" style={{ position: "relative", height: "100vh" }}>
			<PdfComponent pdfUrl={urls} />
		</Box>
	);
});

export default PDFTest;
